import { notify } from 'utils/reduxUtils';

export const types = {
  BOSTON_CENTERLESS_FLOW_CLOSE_MODAL:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_FLOW_CLOSE_MODAL',
  BOSTON_CENTERLESS_UPDATE_FLOW_ERROR:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPDATE_FLOW_ERROR',
  BOSTON_CENTERLESS_UPDATE_FLOW_OPEN_MODAL:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPDATE_FLOW_OPEN_MODAL',
  BOSTON_CENTERLESS_UPDATE_FLOW_REQUEST:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPDATE_FLOW_REQUEST',
  BOSTON_CENTERLESS_UPDATE_FLOW_SUBMIT:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPDATE_FLOW_SUBMIT',
  BOSTON_CENTERLESS_UPDATE_FLOW_SUCCESS:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPDATE_FLOW_SUCCESS',
  BOSTON_CENTERLESS_UPLOAD_FLOW_ERROR:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPLOAD_FLOW_ERROR',
  BOSTON_CENTERLESS_UPLOAD_FLOW_OPEN_MODAL:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPLOAD_FLOW_OPEN_MODAL',
  BOSTON_CENTERLESS_UPLOAD_FLOW_SUBMIT:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPLOAD_FLOW_SUBMIT',
  BOSTON_CENTERLESS_UPLOAD_FLOW_SUCCESS:
    'modules/customWidgets/bostonCenterlessUploadFlow/BOSTON_CENTERLESS_UPLOAD_FLOW_SUCCESS',
};

export const closeModal = () => ({
  type: types.BOSTON_CENTERLESS_FLOW_CLOSE_MODAL,
});

export const bostonCenterlessUploadFlow = {
  error: notify(
    (error) => ({
      type: types.BOSTON_CENTERLESS_UPLOAD_FLOW_ERROR,
      payload: { error },
    }),
    'Failed to create quote item',
  ),
  openModal: () => ({
    type: types.BOSTON_CENTERLESS_UPLOAD_FLOW_OPEN_MODAL,
  }),
  submit: ({
    customAttrs,
    description,
    materialId,
    partName,
    partNumber,
    privateNotes,
    processId,
    publicNotes,
    quantities,
    supplierMaterialId,
  }) => {
    return {
      type: types.BOSTON_CENTERLESS_UPLOAD_FLOW_SUBMIT,
      payload: {
        customAttrs,
        description,
        materialId,
        partName,
        partNumber,
        privateNotes,
        processId,
        publicNotes,
        quantities,
        supplierMaterialId,
      },
    };
  },
  success: () => ({
    type: types.BOSTON_CENTERLESS_UPLOAD_FLOW_SUCCESS,
  }),
};

export const bostonCenterlessUpdateFlow = {
  error: notify(
    (error) => ({
      type: types.BOSTON_CENTERLESS_UPDATE_FLOW_ERROR,
      payload: { error },
    }),
    'Failed to update quote item',
  ),
  openModal: ({
    customAttrs,
    description,
    materialId,
    partName,
    partNumber,
    privateNotes,
    processId,
    publicNotes,
    quantities,
    quoteItemId,
    quoteItemPosition,
    supplierMaterialId,
  }) => ({
    type: types.BOSTON_CENTERLESS_UPDATE_FLOW_OPEN_MODAL,
    payload: {
      initialValues: {
        customAttrs,
        description,
        materialId,
        partName,
        partNumber,
        privateNotes,
        processId,
        publicNotes,
        quantities,
        quoteItemId,
        quoteItemPosition,
        supplierMaterialId,
      },
    },
  }),
  request: ({ component, quoteItem }) => ({
    type: types.BOSTON_CENTERLESS_UPDATE_FLOW_REQUEST,
    payload: { component, quoteItem },
  }),
  submit: ({
    customAttrs,
    description,
    materialId,
    partName,
    partNumber,
    privateNotes,
    processId,
    publicNotes,
    quantities,
    supplierMaterialId,
  }) => {
    return {
      type: types.BOSTON_CENTERLESS_UPDATE_FLOW_SUBMIT,
      payload: {
        customAttrs,
        description,
        materialId,
        partName,
        partNumber,
        privateNotes,
        processId,
        publicNotes,
        quantities,
        supplierMaterialId,
      },
    };
  },
  success: () => ({
    type: types.BOSTON_CENTERLESS_UPDATE_FLOW_SUCCESS,
  }),
};
